import type { CropArea } from '../types/mockup'

export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/7tb7Ff5sMWw8n67MdFqN3v/Mockup_MIR_EN.png'

export const MOCKUP_WIDTH = 1536
export const MOCKUP_HEIGHT = 1024

/** Regions of the mockup reused across the page. */
export const volumesBand: CropArea = { x: 55, y: 128, w: 1420, h: 402 }
export const bonusesBand: CropArea = { x: 380, y: 486, w: 805, h: 245 }
export const devicesArea: CropArea = { x: 55, y: 655, w: 965, h: 290 }
